import { ObjectValues } from 'types';

export const SIZE = { SMALL: 'small', BIG: 'big' } as const;

export type Size = ObjectValues<typeof SIZE>;
